<template>
  <div class="modal fade" id="myModalConfirm" tabindex="-1" role="dialog" aria-labelledby="modalLabelConfirm"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-sm" role="document">
      <div class="modal-content bg-light">
        <div class="modal-header">
          <h6 class="modal-title fs-5" id="modalLabel">
            <strong>{{ this.$store.state.confirmdef.title }}</strong>
          </h6>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          </button>
        </div>
        <div class="modal-body text-left">
          <p v-html="this.$store.state.confirmdef.msg"></p>
        </div>
        <div class="modal-footer">
          <button type="button" id="confirmCancel" class="btn btn-default btn-sm" data-bs-dismiss="modal">{{
              this.$t('lang.toolbar.Cancel') }}</button>
          <button type="button" id="confirm" class="btn btn-info btn-sm"><i class="fa fa-check"></i>
            {{ this.$t('lang.toolbar.OK') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>
<style scoped>
.modal-header {
  padding: 0.8em 1em 0.8em 1em;
  border-bottom: 1px solid #f8f8f8
}

.modal-footer {
  padding: 0.6em;
  border-top: 1px solid #f8f8f8;
}

.btn-default {
  background: #f3f3f3
}

.modal {
  top: 20%;
}
</style>
